export const LOCAL_STORAGE_KEYS = {
  USER_SIGNED_IN: 'user-signed-in',
  IS_LOGGING_OUT: 'is-logging-out',
  CHATBOT_MESSAGE_IMAGES: 'chatbot-message-images',
};
